var ua = navigator.userAgent.toLowerCase();
var isiOS = (ua.indexOf('iphone') > -1) || (ua.indexOf('ipad') > -1);
if(isiOS) {
  var viewport = document.querySelector('meta[name="viewport"]');
  if(viewport) {
    var viewportContent = viewport.getAttribute('content');
    viewport.setAttribute('content', viewportContent + ', user-scalable=no');
  }
}

window.onpageshow = function(event) {
  	if (window.matchMedia( "(max-width: 767px)" ).matches) {
  		//save
    }else{
		if (event.persisted) {
			window.location.reload();
		}
    }
};

$(function() {
  var tp = $(window).scrollTop();
  if(tp != 0) {
    var tp1 = tp - 1;
  	$(window).scrollTop(tp1);
    $(window).scrollTop(tp);
  }
});
$( document ).ready(function() {
var observer = new MutationObserver(function(){
   var test = $('.wishlist-hero-items-count.site-header__cart-count');
   if (test.css('display') == 'none') {
  			$('.wishlist-hero-header-icon').css('opacity','0');
            $('.wishlist-hero-header-icon').css('pointer-events','none');
   }else{
  			$('.wishlist-hero-header-icon').css('opacity','1');
            $('.wishlist-hero-header-icon').css('pointer-events','auto');
  	}
  
  	if($('#wishlist-hero-shared-list-view .MuiButtonGroup-root.MuiButtonGroup-fullWidth > .MuiButtonBase-root.MuiButton-root').length){
		$('#wishlist-hero-shared-list-view .MuiButtonGroup-root.MuiButtonGroup-fullWidth > .MuiButtonBase-root.MuiButton-root').remove();
	}
});

const elem = document.getElementById('whero');
const config = { 
  attributes: true, 
  subtree: true
};
observer.observe(elem, config);
});

$(function(){
  
  $('.search-form__input-wrapper p').on('click', function() {
  	$(this).next().focus();
  });
  
  $(window).scroll(function (){
    var windowH = $(window).height(),
    scrollY = $(window).scrollTop();
    $(".top-section-container .hero").each(function(){
      var imgTopPos = $(this).offset().top;
      var imgChgPos = imgTopPos + $(this).height() / 2;
      var imgBottomPos = imgTopPos + $(this).height();
      if (windowH + scrollY > imgChgPos && scrollY < imgBottomPos) {
        $(this).addClass("visible");
      } else {
        $(this).removeClass("visible");
      }
     　/*
      var ePos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > ePos - windowHeight + windowHeight / 1.8){
        //$(this).css('filter','none');
        $(this).addClass("visible");
      }else{
      	$(this).removeClass("visible");
      }
      */
    });
  });
  
  /*
  $(window).on('load', function() {
  		$('.nav-open > div').on('click', function() {
    		$('.head-top-menu').fadeToggle();
          	$('.head-top-menu').toggleClass('active');
            $('body').toggleClass('b-fixed');
          	$('.nav-open').toggleClass('active');
          	$(this).toggleClass('active');
          	if($(this).hasClass('active')){
        		$('#PageContainer').css('filter','blur(1.2rem)');
            }else{
            	$('#PageContainer').css('filter','unset');
            }
          
          	if (window.matchMedia( "(max-width: 767px)" ).matches) {
  				//save
            }else{
            	if ($('.menu-search-content').css('display') == 'block') {
               		$('.menu-search-content').fadeToggle();
          	   		$('.menu-search-toggle').toggleClass("active");
            	}
            }
          
  		});
  });
  */
  
  $(window).on('load', function() {
  		$('.nav-open').on('click', function() {
    		$('.head-top-menu').fadeToggle();
          	$('.head-top-menu').toggleClass('active');
            $('body').toggleClass('b-fixed');
          	$(this).toggleClass('active');
          	$('.nav-open > div').toggleClass('active');
          	if($('.nav-open > div').hasClass('active')){
        		$('#PageContainer').css('filter','blur(1.2rem)');
              	$('#PageContainer').css('pointer-events','none');
            }else{
            	$('#PageContainer').css('filter','unset');
              	$('#PageContainer').css('pointer-events','auto');
            }
          
          	if (window.matchMedia( "(max-width: 767px)" ).matches) {
  				//$('.head-top-menu').css('opacity','1');
            }else{
            	if ($('.menu-search-content').css('display') == 'block') {
               		$('.menu-search-content').fadeToggle();
          	   		$('.menu-search-toggle').toggleClass("active");
            	}
            }
          
  		});
    	if (window.matchMedia( "(max-width: 767px)" ).matches) {
  			$('.head-top-menu').css('opacity','1');
        }
  });
  
  if (window.matchMedia( "(max-width: 767px)" ).matches) {
  $(document).on('click',function(e) {
   if(!$(e.target).closest('header .medium-up--one-quarter.logo-align--left').length) {
     if($('.nav-open > div').hasClass('active')){
     		$('.head-top-menu').fadeToggle();
          	$('.head-top-menu').toggleClass('active');
            $('body').toggleClass('b-fixed');
          	$('.nav-open').toggleClass('active');
          	$('.nav-open > div').toggleClass('active');
          	$('#PageContainer').css('filter','unset');
            $('#PageContainer').css('pointer-events','auto');
     }
   }
  });
  }
  
  $(".menu-search-toggle").click(function() {
        $(this).toggleClass("active");
		$(this).next().fadeToggle();
  });
  
});

/*
$(function(){
  	var winW = $(window).width();
  	var devW = 767;
  	if (winW <= devW) {
  		$('.nav-open').removeClass('hidden');
    	$('.head-top-menu').addClass('hidden');
      	
      	var horizonal = $('.index-horizon1').offset().top;
      	$(window).on('scroll', function() {
  			if ($(this).scrollTop() > horizonal - 128) {
          		$('header').addClass('scrollin');
          		$('.fixed-logo').removeClass('hidden');
          		$('.top-logo').addClass('hidden');
  			} else {
          		$('header').removeClass('scrollin');
            	$('.fixed-logo').addClass('hidden');
          		$('.top-logo').removeClass('hidden');
  			}
		});
    }else{
  
		var horizonal = $('.index-horizon1').offset().top;
		$(window).on('scroll', function() {
  			if ($(this).scrollTop() > horizonal - 128) {
          		$('header').addClass('scrollin');
				$('.head-top-menu').addClass('hidden');
          		$('.nav-open').removeClass('hidden');
          		$('.fixed-logo').removeClass('hidden');
          		$('.top-logo').addClass('hidden');
  			} else {
          		$('header').removeClass('scrollin');
  				$('.head-top-menu').removeClass('hidden');
          		$('.head-top-menu').css('display','block');
          		$('.nav-open').addClass('hidden');
          		$('.fixed-logo').addClass('hidden');
          		$('.top-logo').removeClass('hidden');
  			}
		});
    }
});
*/
var timer = false;
$(window).on('load', function() {
  	var winW = $(window).width();
  	var devW = 767;
  	spped = 600;
  
  	if (winW <= devW) {

    	$('.index-vertical1').animate({
       		left: 40
    	}, spped);
  		$('.index-vertical2').animate({
        	right: 40
    	}, spped);
    	$('.index-horizon1').animate({
        	bottom: 174
    	}, spped);
      	
      	$('.page-vertical1').animate({
       		left: 40
    	}, spped);
  		$('.page-vertical2').animate({
        	right: 40
    	}, spped);
    	$('.page-horizon1').animate({
        	top: 64
    	}, spped);
      
  	} else {
  		$('.index-vertical1').animate({
       		left: 121
    	}, spped);
  		$('.index-vertical2').animate({
        	right: 121
    	}, spped);
    	$('.index-horizon1').animate({
        	bottom: 151
    	}, spped);
      
      	$('.page-vertical1').animate({
       		left: 121
    	}, spped);
  		$('.page-vertical2').animate({
        	right: 121
    	}, spped);
    	$('.page-horizon1').animate({
        	top: 118
    	}, spped);
  	}

});

$(window).on('scroll', function(){
  	var winW = $(window).width();
  	var devW = 767;
  	spped = 600;
  
    var scrollHeight = $(document).height();
	var scrollPosition = $(window).height() + $(window).scrollTop();
	if ( (scrollHeight - scrollPosition) / scrollHeight <= 0.09) {

      	if (winW <= devW) {
        	
          $('.index-vertical3').animate({
       			left: 40
    		}, spped);
  			$('.index-vertical4').animate({
        		right: 40
    		}, spped);
    		$('.index-horizon2').animate({
        		bottom: 245
    		}, spped);
          
        }else{
       
        	$('.index-vertical3').animate({
       			left: 121
    		}, spped);
  			$('.index-vertical4').animate({
        		right: 121
    		}, spped);
    		$('.index-horizon2').animate({
        		bottom: 110
    		}, spped);
          
        }
    }
});

var userAgent = navigator.userAgent;
var UA_iPhone = (userAgent.indexOf('iPhone') > -1)? true:false;
var UA_iPad = (userAgent.indexOf('iPad') > -1)? true:false;
$(function() {
  if(UA_iPhone || UA_iPad) {
    $('a').bind("mouseover",function(ev) {
      var link = $(this).attr("href");
      var target = $(this).attr("target");
      var linktype = link.substring(0,1);
      if(linktype != "#") {
        if(target == "_blank") {
          window.open(link);
        } else {
          location.href = link;
        }
      }
    });
  }
});

document.getElementsByTagName('body')[0].setAttribute('ontouchstart',''); 
var touch = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
if (touch) {
  try {
    for (var si in document.styleSheets) {
      var styleSheet = document.styleSheets[si];
      if (!styleSheet.rules) continue;
      for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
        if (!styleSheet.rules[ri].selectorText) continue;
        if (styleSheet.rules[ri].selectorText.match(':hover')) {
          //styleSheet.deleteRule(ri);
          styleSheet.rules[ri].selectorText = styleSheet.rules[ri].selectorText.replace(':hover', ':active');
        }
      }
    }
  } catch (ex) {}
}